import { j as o } from "./kezios-design-system.esm172.js";
import { IconComponent as e } from "./kezios-design-system.esm4.js";
const s = (r) => /* @__PURE__ */ o.jsx(e, { ...r, viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M17 5.125A8.5 8.5 0 0 1 12 20.5h-.5M7 18.875A8.5 8.5 0 0 1 12 3.5h.5m.5 18.9-2-2 2-2M11 5.6l2-2-2-2"
  }
) });
export {
  s as IconRefreshCw04
};
